import styled from 'styled-components';

interface DividerWrapperProps {
  marginAround?: string;
}

export const DividerWrapper = styled.hr<DividerWrapperProps>`
  border: none;
  height: 1px;
  margin: ${props =>
    props.marginAround ? `${props.marginAround} 0rem` : '1rem 0rem'};
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.12);
`;
